(() => {
  const SEARCH_PAGE_SELECTOR = '[data-kl-search-page]';
  const SUGGESTIONS_SELECTOR = '[data-kl-search-suggestions]';
  const SUGGESTIONS_LIST_SELECTOR = '[data-kl-search-suggestions-list]';
  const INPUT_SELECTOR = '[data-kl-search-page-input]';
  const CLEAR_SELECTOR = '[data-kl-search-page-clear]';

  const MINIMUM_QUERY_LENGTH = 2;

  function getSuggestionsUrl({ endpoint, baseUrl, query, limit, sectionId }) {
    const suggestionsUrl = new URL(endpoint, baseUrl);

    suggestionsUrl.searchParams.set('q', query);
    suggestionsUrl.searchParams.set('resources[type]', 'collection');
    suggestionsUrl.searchParams.set('resources[limit]', String(limit));
    suggestionsUrl.searchParams.set('section_id', sectionId);

    return suggestionsUrl.toString();
  }

  function getIsQuerySearchable(queryValue) {
    return queryValue.trim().length >= MINIMUM_QUERY_LENGTH;
  }

  function readSuggestionsList(responseText) {
    const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');

    return responseDocument.querySelector(SUGGESTIONS_LIST_SELECTOR);
  }

  async function loadSuggestions(rowElement) {
    const {
      klSearchSuggestionsTerms: terms,
      klSearchSuggestionsLimit: limit,
      klSearchSuggestionsSection: sectionId,
      klSearchSuggestionsUrl: endpoint,
    } = rowElement.dataset;

    if (!terms || !sectionId || !endpoint) return;
    if (!getIsQuerySearchable(terms)) return;

    try {
      const response = await fetch(
        getSuggestionsUrl({
          endpoint,
          baseUrl: rowElement.baseURI,
          query: terms.trim(),
          limit: Number.parseInt(limit, 10) || 4,
          sectionId,
        })
      );

      if (!response.ok) throw new Error(`Shopify answered ${response.status}`);

      const listElement = readSuggestionsList(await response.text());

      if (!listElement) return;

      rowElement.querySelector(SUGGESTIONS_LIST_SELECTOR)?.remove();
      rowElement.append(listElement);
      rowElement.hidden = false;
    } catch (error) {
      console.debug('kl-search-results: could not load suggested collections', { terms, error });
    }
  }

  function initClear(clearElement, inputElement) {
    clearElement.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      event.preventDefault();

      inputElement.value = '';
      clearElement.hidden = true;
      inputElement.focus();
    });

    inputElement.addEventListener('input', () => {
      clearElement.hidden = inputElement.value.length === 0;
    });
  }

  function initSearchPage(pageElement) {
    const rowElement = pageElement.querySelector(SUGGESTIONS_SELECTOR);
    const inputElement = pageElement.querySelector(INPUT_SELECTOR);
    const clearElement = pageElement.querySelector(CLEAR_SELECTOR);

    if (rowElement) loadSuggestions(rowElement);

    if (inputElement && clearElement) initClear(clearElement, inputElement);
  }

  document.querySelectorAll(SEARCH_PAGE_SELECTOR).forEach(initSearchPage);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SEARCH_PAGE_SELECTOR).forEach(initSearchPage);
  });
})();
